<!-- Trigger: quiet button showing the current tier's icon + name (tier name only, never a model name). -->
<button #trigger type="button" class="tier-trigger" [class.open]="$open()" [disabled]="$disabled()" cdkOverlayOrigin #origin="cdkOverlayOrigin" (click)="toggle()">
  <i class="tier-trigger-icon" [class]="$triggerIcon()"></i>
  <span class="tier-trigger-label">{{ $triggerLabel() }}</span>
  <i class="tier-trigger-caret fa-regular fa-chevron-up"></i>
</button>

<!-- Menu: floats above the trigger, closes on backdrop/outside click and on selection. -->
<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="origin" [cdkConnectedOverlayOpen]="$open()" [cdkConnectedOverlayPositions]="OVERLAY_POSITIONS" [cdkConnectedOverlayHasBackdrop]="true" cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop" (backdropClick)="close()" (overlayOutsideClick)="close()" (detach)="close()">
  <div class="tier-menu">
    @for (option of $options(); track option.tier) {
      <button type="button" class="tier-option" [class.selected]="option.tier === $tier()" [disabled]="isRowDisabled(option)" [attr.data-locked-hint]="isRowDisabled(option) ? 'Start a new chat to use this model' : null" (click)="select(option)">
        <i class="tier-option-icon" [class]="option.icon"></i>
        <span class="tier-option-text">
          <span class="tier-option-label">{{ option.label }}</span>
          <span class="tier-option-subtext">{{ option.subtext }}</span>
        </span>
        @if (option.tier === $tier()) {
          <i class="tier-option-check fa-solid fa-check"></i>
        }
      </button>
    }
  </div>
</ng-template>
